import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import { CustomRouteRecord } from "@/router/CustomRouteRecord";
// @ts-ignore
import VueRouteMiddleware from "vue-route-middleware";
import AuthMiddleware from "@/router/middleware/auth";
import RedirectMiddleware from "@/router/middleware/redirect";
import AuthContainer from "@/containers/Auth.vue";
import MembersContainer from "@/containers/Members.vue";
import SignIn from "@/views/SignIn/Index.vue";
import Forbidden from "@/views/Forbidden/Index.vue";
import NotFound from "@/views/NotFound/Index.vue";
import InvoiceList from "@/views/InvoiceList/InvoiceList.vue";
import InvoiceListAuto from "@/views/InvoiceList/InvoiceListAuto.vue";
import NewRegisterOutsourcing from "@/views/NewRegisterOutsourcing/NewRegisterOutsourcing.vue";
import NewRegisterOutsourcingGeneral from "@/views/NewRegisterOutsourcing/NewRegisterOutsourcingGeneral.vue";
import ContractList from "@/views/ContractList/ContractList.vue";
import RegisterContract from "@/views/RegisterContract/RegisterContract.vue";
import RegisterContractAdmin from "@/views/RegisterContract/RegisterContractAdmin.vue";
import Authorization from "@/views/AuthorizationList/AuthorizationList.vue";
import RegisterInvoice from "@/views/RegisterInvoice/RegisterInvoice.vue";
import Home from "@/views/Home/home.vue";
import Reports from "@/views/Reports/Index.vue";
import ReportsSupplier from "@/views/ReportsSupplier/Index.vue";

Vue.use(VueRouter);

const routes: Array<CustomRouteRecord> = [
  // NOT FOUND
  // Componente para las rutas solicitadas por el cliente
  // que no existen en la aplicación. ERROR 404
  // Esta opción no se presenta en el menú de opciones
  // por lo que no tiene la propiedad showInMenu, cuyo
  // valor por default se false.
  {
    component: NotFound,
    path: "/notFound",
    name: "notFound",
  },
  // FORBIDDEN
  // Componente para indicar al usuario que no tiene acceso al módulo
  // al módulo seleccionado
  {
    component: Forbidden,
    path: "/forbidden",
    name: "forbidden",
  },
  // AUTH
  {
    path: "/auth",
    name: "AuthContainer",
    redirect: "auth/signin",
    component: AuthContainer,
    meta: {
      middleware: [RedirectMiddleware],
    },
    children: [
      // SIGNIN
      // Componente para realizar el inicio de sesión
      {
        component: SignIn,
        path: "signin",
        name: "signin",
      },
    ],
  },
  //URL ADMIN-AUTORIZADOR-USUARIO
  {
    path: "/inicio",
    name: "MembersContainerAutorizador",
    component: MembersContainer,
    children: [
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-home-outline",
          label: "Inicio",
        },
        component: Home,
        path: "/inicio",
        name: "inicio-admin-autorizador",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
            },
          ],
        },
      },
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-account-hard-hat",
          label: "Documentos por Proveedor",
        },
        path: "/lista-documentos-proveedor",
        name: "lista-documentos-proveedor",
        component: Authorization,
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Documentos por Proveedor",
              disabled: true,
            },
          ],
        },
      },
      // TERMINOS Y CONDICIONES AUTORIZADOR
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-file-document-outline",
          label: "Documentos de Términos <br> y Condiciones",
        },
        component: ContractList,
        path: "/lista-terminos-condiciones",
        name: "terminos-condiciones-por-proveedor-admin",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Documentos de Términos y Condiciones",
              disabled: true,
            },
          ],
        },
      },
      // FACTURA AUTORIZADOR
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: false,
          //Icono de la opción, para el menú
          icon: "mdi-receipt",
          label: "Facturas",
        },
        component: InvoiceListAuto,
        path: "/lista-factura",
        name: "lista-factura-autorizador",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Documentos por Factura",
              disabled: true,
            },
          ],
        },
      },
      // REPORTES
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-clipboard-file",
          label: "Reportes",
        },
        component: Reports,
        path: "/reportes",
        name: "reportes",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Reportes",
              disabled: true,
            },
          ],
        },
      },
    ],
  },
  // PROVEEDORES
  {
    path: "/",
    name: "MembersContainer",
    component: MembersContainer,
    redirect: "/proveedor/inicio",
    children: [
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-home-outline",
          label: "Inicio",
        },
        component: Home,
        path: "/proveedor/inicio",
        name: "home",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["1", "2", "4", "5"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
            },
          ],
        },
      },
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-account-hard-hat",
          label: "Documentos por Proveedor",
        },
        component: NewRegisterOutsourcing,
        path: "/proveedor/registro",
        name: "registro-stps",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["1", "2", "4", "5"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "home" },
            },
            {
              text: "Documentos por Proveedor",
              disabled: true,
            },
          ],
        },
      },
      // TERMINOS Y CONDICIONES PROVEEDOR
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-file-document-outline",
          label: "Documentos de Términos <br> y Condiciones",
        },
        component: RegisterContract,
        path: "/proveedor/terminos-condiciones",
        name: "terminos-condiciones-por-proveedor",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["1", "2", "4", "5"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "home" },
            },
            {
              text: "Documentos de Términos y Condiciones",
              disabled: true,
            },
          ],
        },
      },
      // LISTA FACTURAS PROVEEDOR
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: false,
          //Icono de la opción, para el menú
          icon: "mdi-receipt",
          label: "Facturas",
        },
        component: InvoiceList,
        path: "/proveedor/lista-factura",
        name: "lista-factura-por-proveedor",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["1", "2", "4", "5"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "home" },
            },
            {
              text: "Documentos por Factura",
              disabled: true,
            },
          ],
        },
      },
      // REPORTES PROVEEDOR
      {
        menu: {
          // Esta opción se presenta en el menú
          visible: true,
          //Icono de la opción, para el menú
          icon: "mdi-clipboard-file",
          label: "Reportes",
        },
        component: ReportsSupplier,
        path: "/proveedor/reportes",
        name: "reportes-proveedor",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: false,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["1", "2", "4", "5"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "home" },
            },
            {
              text: "Reportes",
              disabled: true,
            },
          ],
        },
      },
    ],
  },
  // EN GENERAL
  {
    path: "/proveedor",
    name: "proveedor",
    component: MembersContainer,
    children: [
      {
        path: "/proveedor/:id",
        name: "proveedor_id",
        props: true,
        component: NewRegisterOutsourcingGeneral,
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: [],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb(route: Route, rol?: string) {
            const paramID = route.params.id;
            return [
              {
                text: "Inicio",
                disabled: false,
                to: { name: "inicio-admin-autorizador" },
              },
              {
                text: "Documentos por Proveedor",
                disabled: false,
                to: { name: "lista-documentos-proveedor" },
              },
              {
                text: "Proveedor (" + paramID + ")",
                disabled: true,
              },
            ];
          },
        },
      },
      {
        path: "/factura/:id/:pedido/:folio/:sociedad",
        name: "registro-factura",
        props: true,
        component: RegisterInvoice,
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: [],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb(route: Route, rol?: string) {
            const paramFolio = route.params.folio;
            return [
              {
                text: "Inicio",
                disabled: false,
                to: {
                  name: rol == "3" ? "home" : "inicio-admin-autorizador",
                },
              },
              {
                text: "Documentos por Facturas",
                disabled: false,
                to: {
                  name:
                    rol == "3"
                      ? "lista-factura-por-proveedor"
                      : "lista-factura-autorizador",
                },
              },
              {
                text: "Factura (" + paramFolio + ")",
                disabled: true,
              },
            ];
          },
        },
      },
      // TERMINOS Y CONDICIONES
      {
        component: RegisterContractAdmin,
        path: "/registra-contrato/:id",
        name: "terminos-condiciones-admin",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Documentos de Términos y Condiciones",
              disabled: false,
              to: { name: "terminos-condiciones-por-proveedor-admin" },
            },
            {
              text: "Registro de Documentos de Términos y Condiciones",
              disabled: true,
            },
          ],
        },
      },
      {
        component: RegisterContractAdmin,
        path: "/detalle-terminos-condiciones/:id",
        name: "detalle-terminos-condiciones-admin",
        meta: {
          // Es necesario que el usuario tenga una sesión activa
          isAuthorizationRequired: true,
          // Cualquier role puede ingresar
          allow: ["*"],
          // Rol para denegar acceso
          deny: ["3"],
          middleware: [AuthMiddleware],
          // Items para el Breadcrumbs nav
          breadcrumb: [
            {
              text: "Inicio",
              disabled: false,
              to: { name: "inicio-admin-autorizador" },
            },
            {
              text: "Documentos de Términos y Condiciones",
              disabled: false,
              to: { name: "terminos-condiciones-por-proveedor-admin" },
            },
            {
              text: "Detalle",
              disabled: true,
            },
          ],
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(VueRouteMiddleware());

export default router;
